import { useState } from 'react';
import { SortDirection, SortDirectionType } from '@cmhc-schl/hearth-ui';
import { Ordering } from 'Feature/Arrears/components/ArrearsInquiryPage/core/Ordering';

export const useTableOrdering = (
  ordering: Ordering,
  changeOrdering: (ordering: Ordering) => void
) => {
  const [sortField, setSortField] = useState<string>(
    ordering.field === 'reportingPeriod' ? 'reportingPeriodDate' : 'status'
  );
  const [sortDirection, setSortDirection] = useState<SortDirectionType>(
    ordering.direction === 'asc' ? SortDirection.Ascending : SortDirection.Descending
  );

  const onColumnSort = (column: string) => {
    const reverseDirection =
      sortDirection === SortDirection.Ascending
        ? SortDirection.Descending
        : SortDirection.Ascending;
    const newDirection = column === sortField ? reverseDirection : SortDirection.Descending;

    setSortField(column);
    setSortDirection(newDirection);

    changeOrdering({
      field: column === 'reportingPeriodDate' ? 'reportingPeriod' : 'status',
      direction: newDirection === SortDirection.Ascending ? 'asc' : 'desc'
    });
  };

  return {
    sortField,
    sortDirection,
    onColumnSort
  };
};
